// To distinguish draft diagnoses which are only saved locally
export const DraftDiagnosisStatusId = 'DraftDiagnosis'
